import { BOAXEL as appId } from "./constants";
import storedCatalog from "./rangeConfig/catalog.json";
import storedTemplates from "./rangeConfig/template.json";
import { RangeApi } from "@inter-ikea-storagetwo/range/dist/rangeApi";
import { getCatalogAndTemplate } from "@inter-ikea-storagetwo/range/dist/utils/catalogAndTemplateUtils";
import { calculateOptimalMountingRails, calculateOptimalMountingRailSetupForAllSolutions, calculateOptimalMountingRailSetupForSolution, } from "./utils/calculateOptimalMountingRailSetupForSolution";
import { addSectionFromLeftSide, getUprights } from "./utils/sectionsHelpers";
import { getMountingRailIndexInSolution, indexMountingRailsInSolution, } from "./utils/mountingRailHelpers";
import { MountingRailConnectionService } from "./utils/ConnectorService";
import { recolorSolution } from "./functions/RecolorSolution";
import { changeSectionHeight } from "./functions/ChangeSectionHeight";
import { components } from "./components";
import { systemsDefinitionList } from "./systems";
import { validations } from "./validations";
import { addProductType } from "@inter-ikea-storagetwo/range/dist/functions/productUtils";
import PlannerComponentSerializer from "./PlannerComponentSerializer";
import { Segment } from "@inter-ikea-storagetwo/dexf-utils";
import { CORE_DOESNT_EXIST } from "@inter-ikea-storagetwo/range/dist/constants/errors";
import { MOUNTING_RAIL_CONNECTION_SERVICE_NOT_SET } from "./constants/errors";
import { getRightUprightsOffsetFromLeft } from "./functions/interactiveBoaxelSection";
import { MOUNTING_RAIL_RIGHT_SIDE_UPRIGHT_CONNECTORS } from "./constants/connectorKeys";
export class Boaxel extends RangeApi {
    constructor({ core, env = Segment.production, catalogAndTemplate, }) {
        const { catalog, templates } = getCatalogAndTemplate(catalogAndTemplate, storedCatalog, storedTemplates);
        super({
            core,
            systemsDefinitionList,
            templates,
            catalog,
            env,
            appId,
            components,
            validations,
            componentSerializer: new PlannerComponentSerializer(),
        });
        this.products = [];
        this.calculateOptimalMountingRailSetupForSolution = (mountingRailEntitiesInSolution) => calculateOptimalMountingRailSetupForSolution(this.products, mountingRailEntitiesInSolution);
        this.calculateOptimalMountingRailSetupForAllSolutions = () => {
            if (!this.core)
                throw new Error(CORE_DOESNT_EXIST);
            return calculateOptimalMountingRailSetupForAllSolutions(this.core, this.products);
        };
        this.addSectionFromLeftSide = (currentlyFirstMountingRail, newMountingRail, uprightRef) => {
            if (!this.core)
                throw new Error(CORE_DOESNT_EXIST);
            return addSectionFromLeftSide(this.core, currentlyFirstMountingRail, newMountingRail, uprightRef);
        };
        this.indexMountingRailsInSolution = (mountingRail) => indexMountingRailsInSolution(mountingRail);
        this.getMountingRailIndexInSolution = (mountingRail) => getMountingRailIndexInSolution(mountingRail);
        this.recolorSolution = (color, mountingRails) => {
            if (!this.core)
                throw new Error(CORE_DOESNT_EXIST);
            return recolorSolution(this.core, this.catalog, color, mountingRails);
        };
        this.replaceEntity = (entity) => {
            if (!this.mountingRailConnectionService)
                throw new Error(MOUNTING_RAIL_CONNECTION_SERVICE_NOT_SET);
            return this.mountingRailConnectionService.replace(entity);
        };
        this.changeSectionUprights = (mountingRail) => {
            if (!this.core)
                throw new Error(CORE_DOESNT_EXIST);
            changeSectionHeight(this.core, this.catalog, mountingRail);
        };
        this.mountingRailConnectionService = MountingRailConnectionService(this.core);
        this.fetchRange().then((products) => {
            this.products = Object.values(products);
        });
    }
    init({ viewer, viewerCoreAdapter }) {
        super.init({ viewer, viewerCoreAdapter });
        this.core.services.productManager.subscribeProductCreated(addProductType(this.catalog));
    }
}
const utils = {
    getUprights: getUprights,
    getRightUprightsOffsetFromLeft: getRightUprightsOffsetFromLeft,
    calculateOptimalMountingRails: calculateOptimalMountingRails,
    getRightUprightConnectorKeys: () => MOUNTING_RAIL_RIGHT_SIDE_UPRIGHT_CONNECTORS,
};
export { Boaxel as default, utils };
